import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import swal from "sweetalert";
import user from './../../../images/task/user.jpg';
import { useDispatch, useSelector } from 'react-redux';
import { get_CustomerStoriesData } from '../../../store/actions/CommanAction';
import { AddUpdate, getPostData } from '../../../ApiMethods/ApiMethods';
import { Dropdown, Tab, Nav } from 'react-bootstrap';

const PostPage = () => {

	const dispatch = useDispatch()
	const TaskData = useSelector((state) => state.feedBackReducer.TaskData);
	const customerID = Number(sessionStorage.getItem('ID'));
	const [postModal, setPostModal] = useState(false);
	const [contacts, setContacts] = useState(TaskData);
	const [CustomerStoriesID, setCustomerStoriesID] = useState('');
	const [file, setFile] = React.useState(null)
	const [editModal, setEditModal] = useState(false);
	// const [IsActive, setIsActive] = useState('1');
	const [DeleteState, setDeleteState] = useState('1');
	const [IsActive, setIsActive] = useState(true);
	const [statesChangeStatus, setStatesChangeStatus] = useState(false);
	const [imageUrl, setImageUrl] = useState('');
	//Add data 
	const [addFormData, setaddFormData] = useState({
		Name: '', Designation: '', Comments: '', Stars: '', PhotoUrl: '', IsActive: '1', CreatedByUser: '1'
	});

	useEffect(() => {
		setContacts(TaskData);
	}, [TaskData]);

	// useEffect(() => {
	// 	dispatch(get_CustomerStoriesData(IsActive))
	// }, [IsActive]);
	useEffect(() => {
		if (IsActive) {
			dispatch(get_CustomerStoriesData('1'))
		} else {
			dispatch(get_CustomerStoriesData('0'))
		}
	}, [IsActive, IsActive]);
	// Add contact function
	const handleAddFormChange = (event) => {
		event.preventDefault();
		const fieldName = event.target.getAttribute('name');
		const fieldValue = event.target.value;
		const newFormData = { ...addFormData };
		newFormData[fieldName] = fieldValue;
		setaddFormData(newFormData);
	};

	const handleAddFormSubmit = async (event) => {
		event.preventDefault();
		let error = false;
		let errorMsg = '';
		// Validation checks
		if (addFormData.Comments === "") {
			error = true;
			errorMsg = 'Please fill Comments.';
		} else if (addFormData.Name === "") {
			error = true;
			errorMsg = 'Please fill Name.';
		} else if (addFormData.Designation === "") {
			error = true;
			errorMsg = 'Please fill Designation.';
		} else if (addFormData.Stars === "") {
			error = true;
			errorMsg = 'Please fill Stars..';
		}
		if (!error) {
			const formData = new FormData();
			const dataObject = {
				Name: addFormData.Name, Designation: addFormData.Designation, Stars: addFormData.Stars, Comments: addFormData.Comments, IsActive: addFormData.IsActive
			};
			formData.append('Data', JSON.stringify(dataObject)); formData.append('File', file);
			await AddUpdate('CustomerStories/Insert_CustomerStories', formData);
			setPostModal(false); dispatch(get_CustomerStoriesData(IsActive));
			swal('Good job!', 'Successfully Added', "success");
			// Reset form fields
			setaddFormData({ Name: '', Designation: '', Comments: '', Stars: '', PhotoUrl: '', IsActive: '' });
			setFile(null); // Reset the file state
		} else {
			swal('Oops', errorMsg, "error");
		}
	};
	const handleEditClick = async (event, contact) => {
		event.preventDefault();
		setCustomerStoriesID(contact.CustomerStoriesID);
		const newCustomerStory = { 'CustomerStoriesID': contact.CustomerStoriesID };

		const formValues = {
			Name: contact.Name,
			Designation: contact.Designation,
			Comments: contact.Comments,
			Stars: contact.Stars,
			IsActive: contact.IsActive,
			PhotoUrl: contact.PhotoUrl // Set existing PhotoUrl
		};

		// Set the form data including the existing image URL
		setaddFormData(formValues);
		setFile(null); // Reset the file state when editing starts (optional)
		setEditModal(true);
	};


	//update data function
	// const handleEditFormChange = (event) => {
	// 	event.preventDefault();
	// 	const fieldName = event.target.getAttribute('name');
	// 	const fieldValue = event.target.value;
	// 	const newFormData = { ...addFormData };
	// 	newFormData[fieldName] = fieldValue;
	// 	setaddFormData(newFormData);
	// };
	useEffect(() => {
		let url;

		if (file && (file instanceof File || file instanceof Blob)) {
			url = URL.createObjectURL(file);
			setImageUrl(url);
		} else if (addFormData.PhotoUrl) {
			setImageUrl(`https://${addFormData.PhotoUrl.replace(/\\/g, '/')}`);
		} else {
			setImageUrl(user);
		}

		// Clean up the object URL if one was created
		return () => {
			if (url) {
				URL.revokeObjectURL(url);
			}
		};
	}, [file, addFormData.PhotoUrl, user]);
	useEffect(() => {
		const storedData = localStorage.getItem('formData');
		if (storedData) {
			setaddFormData(JSON.parse(storedData));
		}
	}, []);
	const handleEditFormChange = (event) => {
		event.preventDefault();
		const fieldName = event.target.getAttribute('name');
		const fieldValue = event.target.value;

		const newFormData = {
			...addFormData,
			[fieldName]: fieldName === 'Stars' ? Math.min(Math.max(fieldValue, 0), 5) : fieldValue, // Constrain Stars
		};

		setaddFormData(newFormData);
	};
	// edit form data submit

	// const handleEditFormSubmit = async (event) => {
	// 	event.preventDefault();
	// 	const editedContact = {
	// 		CustomerStoriesID: CustomerStoriesID, Name: addFormData.Name, Designation: addFormData.Designation, Comments: addFormData.Comments,
	// 		Stars: addFormData.Stars, IsActive: addFormData.IsActive, PhotoUrl: addFormData.PhotoUrl,
	// 	};
	// 	try {
	// 		const response = await AddUpdate('CustomerStories/Update_CustomerStories', editedContact);
	// 		if (!response.success) {
	// 			const newContacts = [...contacts];
	// 			const index = contacts.findIndex((contact) => contact.CustomerStoriesID === CustomerStoriesID);
	// 			newContacts[index] = editedContact;
	// 			setContacts(newContacts); swal('Good job!', 'Successfully Updated', 'success');
	// 		}
	// 		else { swal('Oops', 'Update failed', 'error'); }
	// 	}
	// 	catch (error) { swal('Oops', 'Something went wrong', 'error'); }
	// 	finally {
	// 		setCustomerStoriesID(null); setEditModal(false);
	// 	};
	// };

	// new
	const handleEditFormSubmit = async (event) => {
		event.preventDefault();
		let error = false;
		let errorMsg = '';

		// Validation checks
		if (addFormData.Comments === "") {
			error = true;
			errorMsg = 'Please fill in the Comments.';
		} else if (addFormData.Name === "") {
			error = true;
			errorMsg = 'Please fill in the Name.';
		} else if (addFormData.Designation === "") {
			error = true;
			errorMsg = 'Please fill in the Designation.';
		} else if (addFormData.Stars === "") {
			error = true;
			errorMsg = 'Please fill in the Stars.';
		}

		// If there's an error, show a message and stop the submission
		if (error) {
			swal('Validation Error', errorMsg, 'warning');
			return; // Exit the function early
		}

		const editedContact = {
			CustomerStoriesID,
			Name: addFormData.Name,
			Designation: addFormData.Designation,
			Comments: addFormData.Comments,
			Stars: addFormData.Stars,
			IsActive: addFormData.IsActive,
			PhotoUrl: addFormData.PhotoUrl,
		};

		try {
			const response = await AddUpdate('CustomerStories/Update_CustomerStories', editedContact);

			if (!response.success) {
				const newContacts = [...contacts];
				const index = contacts.findIndex((contact) => contact.CustomerStoriesID === CustomerStoriesID);
				newContacts[index] = editedContact;
				setContacts(newContacts);
				swal('Good job!', 'Successfully Updated', 'success');
			} else {
				swal('Oops', 'Update failed', 'error');
			}
		} catch (error) {
			console.error("Error updating contact:", error);
			swal('Oops', 'Something went wrong', 'error');
		} finally {
			setCustomerStoriesID(null);
			setEditModal(false); setaddFormData({ Name: '', Designation: '', Comments: '', Stars: '', PhotoUrl: '', IsActive: '' });
		}
	};


	// const fileHandler = (e) => {
	// 	setStatesChangeStatus(true)
	// 	const file = e.target.files[0];
	// 	if (file) {
	// 		setFile(file);
	// 	}
	// };
	const fileHandler = (e) => {
		setStatesChangeStatus(true);
		const file = e.target.files[0];
		const allowedExtensions = /(\.apng|\.png|\.jpg|\.jpeg|\.jfif|\.pjpeg|\.pjp)$/i;

		if (file) {
			if (allowedExtensions.exec(file.name)) {
				setFile(file);
			} else {
				swal('Please upload a valid image file');
			}
		}
	};

	const handleToggleStatusClick = async (contactId, currentStatus, isActiveValue) => {
		const postData = {
			CustomerStoriesID: contactId,
			DeleteByUser: customerID,
			IsActive: isActiveValue,
		};
		await AddUpdate('CustomerStories/Delete_CustomerStories', postData);
		dispatch(get_CustomerStoriesData(currentStatus ? '1' : '0'))
		swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");
	};


	const handleUpdatePhoto = async () => {
		// if (!file) {
		// 	swal('Error', 'Please select a photo to upload', 'error');
		// 	return;
		// }
		const formData = new FormData();
		const dataObject = {
			CustomerStoriesID: CustomerStoriesID,
			ModifiedByUser: '1',
			// Files: Files,
		};
		formData.append('Data', JSON.stringify(dataObject)); formData.append('File', file);
		await AddUpdate('CustomerStories/UpdateCustomerPhoto', formData);
		setPostModal(false); dispatch(get_CustomerStoriesData(IsActive));
		swal('Good job!', 'Successfully Added', "success");
		// Reset form fields
		setaddFormData({ Name: '', Designation: '', Comments: '', Stars: '', PhotoUrl: '', IsActive: '' });
		setFile(null); // Reset the file state
		setEditModal(false);
		setStatesChangeStatus(false)
	}

	return (
		<>
			<Tab.Container defaultActiveKey="All">
				<div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
					<div className="card-action coin-tabs">
						<Nav as="ul" className="nav nav-tabs" role="tablist">
							<Nav.Item as="li" className="nav-item">
								<Nav.Link className="nav-link" eventKey="All" onClick={(currentStatus) => {
									setIsActive(true);
								}} >Active</Nav.Link>
							</Nav.Item>
							<Nav.Item as="li" className="nav-item">
								<Nav.Link className="nav-link" eventKey="Inactive" onClick={(currentStatus) => {
									setIsActive(false);
								}}>Inactive</Nav.Link>
							</Nav.Item>
						</Nav>
					</div>
					<Link to={"#"} className="btn btn-primary font-w600 " onClick={() => setPostModal(true)}>+ New Feedback</Link>
				</div>
				<div className="row">
					<div className="col-xl-12">
						<div className="">
							<div className=" p-0">
								<Tab.Content>
									<Tab.Pane eventKey="All">
										<div className="mb-sm-5 mb-3 d-flex flex-wrap align-items-center text-head">
											<Modal className="modal fade" show={postModal} onHide={setPostModal} >
												<div className="" role="document">
													<div className="">
														<form >
															<div className="modal-header">
																<h4 className="modal-title fs-20">Add Feedback</h4>
																<button type="button" className="btn-close" onClick={() => setPostModal(false)} data-dismiss="modal"></button>
															</div>
															<div className="modal-body">
																<i className="flaticon-cancel-12 close"></i>
																<div className="add-contact-box">
																	<div className="add-contact-content">
																		<div className="image-placeholder">
																			<div className="avatar-edit">
																				<input type="file" onChange={fileHandler} id="imageUpload"
																					onClick={(event) => setFile(event.target.value)}
																				// onClick={(event) => setFile(event.target.value)}
																				// accept=".apng, .png, .jpg, .jpeg, .jfif, .pjpeg, .pjp"
																				/>
																				<label htmlFor="imageUpload" name=''  ></label>
																			</div>
																			<div className="avatar-preview">
																				<div id="imagePreview">
																					{/* <img id="saveImageFile" src={file ? URL?.createObjectURL(file) : user}
																						alt={file ? file.name : null}
																					/> */}
																					<img
																						id="saveImageFile"
																						src={imageUrl}
																						alt={file ? file.name : 'User image'}
																					/>
																				</div>
																			</div>
																		</div>

																		<div className="row">
																			<div className="col-6">
																				<div className="form-group mb-3">
																					<label className="text-black font-w500">Name</label>
																					<span className="text-danger star-error" >*</span>
																					<div className="contact-name">
																						<input type="text" className="form-control" autoComplete="off"
																							name="Name" required="required"
																							onChange={handleAddFormChange}
																							placeholder="Enter Your Name"
																							maxLength={25}
																						/>
																						<span className="validation-text"></span>
																					</div>
																				</div>
																				<div className="form-group mb-3">
																					<label className="text-black font-w500">Designation</label>
																					<span className="text-danger star-error" >*</span>
																					<div className="contact-name">
																						<input type="text" className="form-control" autoComplete="off"
																							name="Designation" required="required"
																							onChange={handleAddFormChange}
																							placeholder="Enter Your Designation"
																						/>
																						<span className="validation-text"></span>
																					</div>
																				</div>

																				<div className="form-group mb-3">
																					<label className="text-black font-w500">Stars</label>
																					<span className="text-danger star-error" >*</span>
																					<div className="contact-occupation">
																						<input
																							type="number"
																							autoComplete="off"
																							name="Stars"
																							required
																							onChange={handleAddFormChange}
																							className="form-control"
																							placeholder=""
																							min={0}
																							max={5}
																							onInput={(e) => {
																								if (e.target.value < 0) e.target.value = 0; // Set to 0 if below 0
																								if (e.target.value > 5) e.target.value = 5; // Set to 5 if above 5
																							}}
																							onKeyDown={(e) => {
																								e.preventDefault();
																							}}
																						/>
																					</div>
																				</div>
																			</div>
																			<div className="col-6">
																				<div className="form-group mb-3">
																					<label className="text-black font-w500">Comments</label>
																					<span className="text-danger star-error" >*</span>
																					<div className="contact-occupation">
																						<textarea rows={11} cols={6} autoComplete="off"
																							onChange={handleAddFormChange}
																							name="Comments" required="required"
																							className="form-control" placeholder="Enter Comments"
																							maxLength={500}>
																						</textarea>
																					</div>
																				</div>
																			</div>


																		</div>
																	</div>
																</div>
															</div>
															<div className="modal-footer">
																<button type="submit" className="btn btn-primary" onClick={handleAddFormSubmit}>Add</button>
																<button type="button" onClick={() => { setPostModal(false); setFile('') }} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Close</button>
															</div>
														</form>
													</div>
												</div>
											</Modal>
											<Modal className="modal fade" show={editModal} onHide={setEditModal} >
												<div className="" role="document">
													<div className="">
														<form >
															<div className="modal-header">
																<h4 className="modal-title fs-20">Edit Feedback</h4>
																<button type="button" className="btn-close" onClick={() => setEditModal(false)} data-dismiss="modal"></button>
															</div>
															<div className="modal-body">
																<i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
																<div className="add-contact-box">
																	<div className="add-contact-content">
																		<div className="image-placeholder">
																			<div className="avatar-edit">
																				<input
																					type="file"
																					onChange={fileHandler}
																					id="imageUpload"
																				/>
																				<label htmlFor="imageUpload"></label>
																			</div>
																			<div className="avatar-preview">
																				<div id="imagePreview">
																					{/* <img
																						id="saveImageFile"
																						src={file ? URL?.createObjectURL(file) : (addFormData.PhotoUrl ? `https://${addFormData.PhotoUrl.replace(/\\/g, "/")}` : user)}
																						alt={file ? file.name : 'User Avatar'}
																					/> */}
																					<img
																						id="saveImageFile"
																						src={imageUrl}
																						alt={file ? file.name : 'User Avatar'}
																					/>
																				</div>
																			</div>
																		</div>

																		<div className="row">
																			<div className="col-6">
																				<div className="form-group mb-3">
																					<label className="text-black font-w500">Name</label>
																					<span className="text-danger star-error" >*</span>
																					<div className="contact-name">
																						<input type="text" className="form-control" autoComplete="off"
																							name="Name" required="required"
																							value={addFormData.Name}
																							onChange={handleEditFormChange}
																							maxLength={25}

																						/>
																						<span className="validation-text"></span>
																					</div>
																				</div>
																				<div className="form-group mb-3">
																					<label className="text-black font-w500">Designation</label>
																					<span className="text-danger star-error" >*</span>
																					<div className="contact-name">
																						<input type="text" className="form-control" autoComplete="off"
																							name="Designation" required="required"
																							value={addFormData.Designation}
																							onChange={handleEditFormChange}
																						/>
																						<span className="validation-text"></span>
																					</div>
																				</div>
																				<div className="form-group mb-3">
																					<label className="text-black font-w500">Stars</label>
																					<span className="text-danger star-error" >*</span>
																					<div className="contact-occupation">
																						<input
																							type="number"
																							autoComplete="off"
																							name="Stars"
																							required
																							onChange={handleEditFormChange}
																							className="form-control"
																							placeholder=""
																							min={0}
																							max={5}
																							value={addFormData.Stars}
																							onInput={(e) => {
																								if (e.target.value < 0) e.target.value = 0; // Set to 0 if below 0
																								if (e.target.value > 5) e.target.value = 5; // Set to 5 if above 5
																							}}
																							onKeyDown={(e) => {
																								e.preventDefault(); // Prevent typing
																							}}
																						/>
																					</div>

																				</div>
																			</div>
																			<div className="col-6">
																				<div className="form-group mb-3">
																					<label className="text-black font-w500">Comments</label>
																					<span className="text-danger star-error" >*</span>
																					<div className="contact-occupation">
																						<textarea rows={11} cols={6} autoComplete="off"
																							value={addFormData.Comments}
																							onChange={handleEditFormChange}
																							name="Comments" required="required"
																							className="form-control" placeholder="Enter Comments"
																							maxLength={500}>
																						</textarea>
																					</div>
																				</div>
																			</div>
																		</div>


																	</div>
																</div>
															</div>
															<div className="modal-footer">
																<button type="submit" className="btn btn-primary" onClick={handleEditFormSubmit}>Update</button>
																<button type="button" className="btn btn-secondary" disabled={!statesChangeStatus} onClick={handleUpdatePhoto}>Update Photo</button>
																<button type="button" onClick={() => { setEditModal(false); setFile('') }} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Close</button>
															</div>
														</form>
													</div>
												</div>
											</Modal>
										</div>
										<div className="row">
											{/* {Array.isArray(contacts) && contacts.map((contact, index) => ( */}
											{Array.isArray(contacts) && contacts.filter(contact => contact.IsActive).map((contact, index) => (
												<div className="col-xl-3 col-xxl-4 col-lg-6 col-md-6 col-sm-6" key={index}>
													<div className="card project-boxed">
														{/* <div className="img-bx">
															<img
																// src={`https://${contact.PhotoUrl.replace(/\\/g, "/")}`}
																src={contact.PhotoUrl ? `https://${contact.PhotoUrl.replace(/\\/g, "/")}` : 'default-image-url.jpg'} // Provide a default image URL

																alt="" className="me-3 card-list-img w-100" width="130" style={{ height: '200px' }}
															/>
														</div> */}
														<div className="img-bx">
															{contact.PhotoUrl ? (
																<img
																	src={`https://${contact.PhotoUrl.replace(/\\/g, "/")}`}
																	alt=""
																	className="me-3 card-list-img w-100"
																	width="130"
																	style={{ height: '200px' }}
																/>
															) : (
																<div style={{ height: '200px', width: '130px' }}></div>
															)}
														</div>

														<div className="card-header ">
															<div>
																{/* <p className="fs-14 mb-2 text-primary">#{contact.CustomerStoriesID}</p> */}
																<h6 className="fs-18 font-w500 mb-3 ">
																	{/* <Link to={"#"} className="text-black user-name">{contact.Name}</Link> */}
																	<Link to={"#"} className="text-black user-name " style={{ marginLeft: '-5px' }}>
																		{contact.Name.length > 40 ? `${contact.Name.substring(0, 20)}...` : contact.Name}
																	</Link>
																</h6>
															</div>
															<Dropdown>
																<Dropdown.Toggle variant="" as="div" className="btn-link i-false">
																	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																		<path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																		<path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	</svg>
																</Dropdown.Toggle>
																<Dropdown.Menu alignRight={true} className="dropdown-menu-right">
																	<Dropdown.Item onClick={(event) => handleEditClick(event, contact)}>Edit</Dropdown.Item>
																	{/* <Dropdown.Item className="text-danger" onClick={() => handleDeleteClick(contact.CustomerStoriesID)}>Inactive</Dropdown.Item> */}
																	<Dropdown.Item
																		className={contact.IsActive ? "text-danger" : "text-success"}
																		onClick={() => {
																			handleToggleStatusClick(contact.CustomerStoriesID, true, '0'); // Pass the new IsActive value
																		}}>
																		Inactive
																	</Dropdown.Item>
																</Dropdown.Menu>
															</Dropdown>
														</div>
														<div className="card-body p-0 pb-3">
															<ul className="list-group list-group-flush">
																<li className="list-group-item">
																	<span className="mb-0 title">Designation</span>:
																	<span className="text-black ms-2">{contact.Designation}</span>
																</li>
																<li className="list-group-item" style={{ height: '100px', overflowY: "scroll" }}>
																	<span className="mb-0 title">Comments</span>:
																	<span className="text-black ms-2" >{contact.Comments}</span>
																</li>
																<li className="list-group-item">
																	<div className="star-review">
																		<span className="mb-0 title " >Stars:</span>
																		{Array(contact.Stars).fill().map((_, idx) => (
																			<i className="fa fa-star text-orange me-1" key={idx}></i>
																		))}
																	</div>
																</li>
															</ul>
														</div>
													</div>
												</div>
											))}
										</div>
										{/* {contacts && Array.isArray(contacts) && contacts.filter(contact => !contact.IsActive).map((contact, index) => ( */}

									</Tab.Pane>
									<Tab.Pane eventKey="Inactive">
										<div className="row">
											{/* {Array.isArray(contacts) && contacts.map((contact, index) => ( */}
											{contacts && Array.isArray(contacts) && contacts.filter(contact => !contact.IsActive).map((contact, index) => (
												<div className="col-xl-3 col-xxl-4 col-lg-6 col-md-6 col-sm-6" key={index}>
													<div className="card project-boxed">
														<div className="img-bx">
															<img
																// src={`https://${contact.PhotoUrl.replace(/\\/g, "/")}`}
																src={contact.PhotoUrl ? `https://${contact.PhotoUrl.replace(/\\/g, "/")}` : 'default-image-url.jpg'} // Provide a default image URL

																alt="" className="me-3 card-list-img w-100" width="130" style={{ height: '200px' }}
															/>
														</div>
														<div className="card-header align-items-start">
															<div>
																{/* <p className="fs-14 mb-2 text-primary">#{contact.CustomerStoriesID}</p> */}
																<h6 className="fs-18 font-w500 mb-3">
																	{/* <Link to={"#"} className="text-black user-name">{contact.Name}</Link> */}
																	<Link to={"#"} className="text-black user-name">
																		{contact.Name.length > 40 ? `${contact.Name.substring(0, 20)}...` : contact.Name}
																	</Link>
																</h6>
															</div>
															<Dropdown>
																<Dropdown.Toggle variant="" as="div" className="btn-link i-false">
																	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																		<path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																		<path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	</svg>
																</Dropdown.Toggle>
																<Dropdown.Menu alignRight={true} className="dropdown-menu-right">
																	{/* <Dropdown.Item onClick={(event) => handleEditClick(event, contact)}>Edit</Dropdown.Item> */}
																	{/* <Dropdown.Item className="text-danger" onClick={() => handleDeleteClick(contact.CustomerStoriesID)}>Inactive</Dropdown.Item> */}
																	<Dropdown.Item className={contact.IsActive ? "text-danger" : "text-success"}
																		// onClick={() => {
																		// 	const newIsActive = contact.IsActive ? '1' : '0';
																		// 	handleToggleStatusClick(contact.CustomerStoriesID, contact.IsActive, newIsActive);
																		// 	setIsActive(newIsActive);
																		// 	setDeleteState(newIsActive === '0' ? '1' : '1');
																		// }}>
																		// {contact.IsActive ? 'Inactive' : 'Activate'}
																		onClick={() => {
																			handleToggleStatusClick(contact.CustomerStoriesID, false, '1');
																		}}>
																		Activate
																	</Dropdown.Item>
																</Dropdown.Menu>
															</Dropdown>
														</div>
														<div className="card-body p-0 pb-3">
															<ul className="list-group list-group-flush">
																<li className="list-group-item">
																	<span className="mb-0 title">Designation</span>:
																	<span className="text-black ms-2">{contact.Designation}</span>
																</li>
																<li className="list-group-item" style={{ height: '100px', overflowY: "scroll" }}>
																	<span className="mb-0 title">Comments</span>:
																	<span className="text-black ms-2">{contact.Comments}</span>
																</li>
																<li className="list-group-item">
																	<div className="star-review">
																		<span className="mb-0 title px-2" >Stars:</span>
																		{Array(contact.Stars).fill().map((_, idx) => (
																			<i className="fa fa-star text-orange me-1" key={idx}></i>
																		))}
																	</div>
																</li>
															</ul>
														</div>
													</div>
												</div>
											))}
										</div>
									</Tab.Pane>
								</Tab.Content>
							</div>
						</div>
					</div >
				</div >
			</Tab.Container >
		</>
	);
}
export default PostPage;